// extracted by mini-css-extract-plugin
export default {"multiple-mode-text-container":"styles-module_multiple-mode-text-container---eGoDg","mode-selector":"styles-module_mode-selector---V0lIZ"};